import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate} from "react-intl";
import moment from 'moment';
import {DateParse} from '../Form/utils';

class FormaterDate extends React.Component {

    otherProps = {};

    constructor(props) {
        super(props);

        let {value, ...otherProps} = this.props;

        value = DateParse(value, value);

        this.otherProps = otherProps;

        this.state = {value};
    }

    render() {
        let {month, year, day, ...other} = this.otherProps;
        return (
            <FormattedDate
                value={this.state.value}
                day={day || "2-digit"}
                month={month || "2-digit"}
                year={year || "numeric"}
                {...other}
            />
        );
    }
}

FormaterDate.propTypes = {
    value: PropTypes.string
};

export default FormaterDate;
